import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { RouteParams } from '@/router/type';
import { useGetDedicateInstance } from '@/service/one-click-deploy/hook';
import { StatusGetInstances } from '@/service/one-click-deploy/type';
import { useParams } from 'react-router-dom';

export const useGetDedicateInstanceById = () => {
  const { workspaceId } = useParamWorkspaceId();
  const { instanceId } = useParams<RouteParams>();
  const query = useGetDedicateInstance(
    {
      instance_id: instanceId!,
      workspace_id: workspaceId,
    },
    {
      staleTime: 1000 * 60,
      refetchInterval: (data) => {
        if (
          data?.state?.data?.status === StatusGetInstances.Initial ||
          data?.state?.data?.status === StatusGetInstances.Allocate
        ) {
          return 5000; // refetch every 5 seconds
        }
        return false;
      },
    }
  );
  return query;
};
